import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { UserEffects } from './user.effects';
import { usersReducer } from './user.reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('users', usersReducer), EffectsModule.forFeature([UserEffects])],
  providers: [],
})
export class UserStoreModule {}
